module.exports = __webpack_public_path__ + "assets/media/lunch.62d9ae7e.mp3";